import { useEffect } from "react";
import { track } from "./api";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export function useSEO({ title, description, schema }) {
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "The Nanny Sleep Co.");

    document.head.querySelectorAll("script[data-nsc-schema]").forEach((el) => el.remove());
    if (schema) {
      const list = Array.isArray(schema) ? schema : [schema];
      list.forEach((s) => {
        const el = document.createElement("script");
        el.type = "application/ld+json";
        el.setAttribute("data-nsc-schema", "true");
        el.textContent = JSON.stringify(s);
        document.head.appendChild(el);
      });
    }
  }, [title, description, schema]);
}

export function usePageView(page) {
  useEffect(() => {
    track("landing_view", {}, page);
  }, [page]);
}
